import {action, observable} from 'mobx';

class ViihdeFooterStore
{
  @observable items = [];

  @action setItems(array)
  {
    this.items = array.map(item => Object.assign({}, item));
  }
}

const store = new ViihdeFooterStore();
export default store;



// WEBPACK FOOTER //
// ./web/js/components/footer/ViihdeFooterStore.js